export const shiftClasses = {
  badgeText: (labelColor: string) => ({ color: labelColor, width: '100%', lineHeight: 1 }),
}
